export default "__VITE_ASSET__TkD1VJOv__"